<!--
* App's chat widget, displays little button, clicking it opens chat widget
* provided by third-party
*
* @param {String} chatWidgetScriptUrl - unique url widget uses to load it's contents
-->
<template>
  <div class="chat">
    <!-- icon -->
    <a
      class="chat__icon"
      v-on:click="startChat()"
      href="javascript:void(0)"
      >
      <i class="fas fa-comments fa-lg"></i>
      <p class="chat__title">{{title}}</p>
    </a>
    <p class="chat__subtitle">{{subtitle}}</p>
  </div>
</template>

<script>
export default {
  name: 'AppChatWidget',
  props: {
    chatWidgetScriptUrl: {
      required: true,
      type: String
    },
    // title next to the icon
    title: {
      type: String
    },
    // subtitle below the icon
    subtitle: {
      type: String
    }
  },
  mounted () {
  },
  methods: {
    startChat () {
      if (!window.open(this.chatWidgetScriptUrl, '_blank', 'width=500, height=500')) {
        // if the popup window didn't open then we try to open in new tab instead
        window.open(this.chatWidgetScriptUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/sass/main.scss";
.chat {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

}
.chat__icon {
  height: $dims-header-icon-size;
  * {
    color: $white;
    display: inline-flex;
  }
}
.chat__title {
  margin-left: $dims-spacing-small;
}

.chat__title, .chat__subtitle {
  color: $white;
}
</style>
